import Highcharts from "highcharts";

export const createMultiAxisChartOptions = (chartData, startDate) => ({
  chart: {
    zooming: { type: "xy" },
  },
  title: { text: "" },
  xAxis: [{
    type: "datetime",
    crosshair: true,
    labels: {
      formatter: function() {
        return Highcharts.dateFormat("%d", this.value);
      },
      rotation: -45,
      style: {
        fontSize: '12px'
      }
    },
    tickInterval: 24 * 3600 * 1000,
  }],
  yAxis: [
    {
      title: { text: "", style: { color: Highcharts.getOptions().colors[0] } },
      labels: { format: "{value}", style: { color: Highcharts.getOptions().colors[0] } },
    },
    {
      title: { text: "", style: { color: Highcharts.getOptions().colors[1] } },
      labels: { format: "{value} USD", style: { color: Highcharts.getOptions().colors[1] } },
      opposite: true,
    },
  ],
  tooltip: { 
    shared: true,
    formatter: function() {
      const date = Highcharts.dateFormat("%d", this.x);
      let tooltipHTML = `<b>${date}</b><br/>`;
      this.points.forEach(point => {
        tooltipHTML += `${point.series.name}: <b>${point.y}</b>${point.series.name === 'Profit' ? ' USD' : ' calls'}<br/>`;
      });
      return tooltipHTML;
    }
  },
  series: [
    {
      name: "Total Calls",
      type: "column",
      data: chartData.map((item) => [item.x, item.incoming]),
      color: "#4285F4",
    },
    {
      name: "Answered Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.answer]),
      color: "#87CEEB",
    },
    {
      name: "Missed Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.miscall]),
      color: "#FF0000",
    },
    {
      name: "Cancel Calls",
      type: "line",
      data: chartData.map((item) => [item.x, item.cancelcalls]),
      color: "#FF0000",
    },
    {
      name: "Profit",
      type: "line",
      yAxis: 1,
      data: chartData.map((item) => [item.x, item.profit]),
      color: "#34A853",
      marker: { enabled: false },
    },
  ],
  plotOptions: {
    series: {
      pointStart: new Date(startDate).getTime(),
      pointInterval: 24 * 3600 * 1000
    }
  }
});

export const createPieChartOptions = (pieChartData) => ({
  chart: { type: "pie" },
  title: { text: "Extension Call" },
  series: [
    {
      name: "Calls",
      colorByPoint: true,
      data: pieChartData,
    },
  ],
});

export const createTopUsersPieChartOptions = (topUsersData, startDate, endDate) => ({
  chart: { 
    type: "pie",
    height: '400px'
  },
  title: { 
    text: "",
    style: {
      fontSize: '16px'
    }
  },
//   subtitle: {
//     text: startDate && endDate 
//       ? `Based on total duration in minutes (${startDate} to ${endDate})`
//       : 'No date range selected',
//     style: {
//       fontSize: '12px'
//     }
//   },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.y} minutes</b>'
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name} :</b> </br> {point.y} min',
        style: {
          fontSize: '11px'
        }
      }
    }
  },
  // series: [{
  //   name: 'Duration',
  //   colorByPoint: true,
  //   data: topUsersData.length > 0 
  //     ? topUsersData 
  //     : [{ name: 'No Data', y: 0, color: '#cccccc' }]
  // }]
 series: [{
    name: 'Duration',
    colorByPoint: true,
    data: topUsersData.length > 0
      ? topUsersData.map(user => ({
          name: user.name,
          y: parseFloat(user.y.toFixed(2)), // Round to two decimal places
          // color: user.color || '#cccccc' // Set default color if 'user.color' is not available
      }))
      : [{ name: 'No Data', y: 0, color: '#cccccc' }]
}]


});